import { create } from 'zustand';

type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

interface SocketStoreState {
  status: ConnectionStatus;
  lastHeartbeat: string | null;
  reconnectAttempts: number;
  activeRoomIds: string[];
  setStatus: (status: ConnectionStatus) => void;
  setLastHeartbeat: (timestamp: string) => void;
  incrementReconnect: () => void;
  resetReconnect: () => void;
  setActiveRoomIds: (ids: string[]) => void;
  addActiveRoom: (id: string) => void;
  removeActiveRoom: (id: string) => void;
}

export const useSocketStore = create<SocketStoreState>((set) => ({
  status: 'disconnected',
  lastHeartbeat: null,
  reconnectAttempts: 0,
  activeRoomIds: [],
  setStatus: (status) => set({ status }),
  setLastHeartbeat: (lastHeartbeat) => set({ lastHeartbeat }),
  incrementReconnect: () => set((s) => ({ reconnectAttempts: s.reconnectAttempts + 1 })),
  resetReconnect: () => set({ reconnectAttempts: 0 }),
  setActiveRoomIds: (activeRoomIds) => set({ activeRoomIds }),
  addActiveRoom: (id) => set((s) => ({ activeRoomIds: [...new Set([...s.activeRoomIds, id])] })),
  removeActiveRoom: (id) => set((s) => ({ activeRoomIds: s.activeRoomIds.filter((r) => r !== id) })),
}));
